import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-img',
    templateUrl: './icon-img.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconImgComponent {
    @Input() isActive: boolean = false;
}
